import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  ccProviderTitle: 'Recipient details',
  ccEntityTitle: 'Entity',
  ccEntityPerson: 'Person',
  ccEntityCompany: 'Company',
  ccRepresentativeName: 'Contact name',
  ccName: 'Name',
  ccContactPhone: 'Contact phone (Optional)',
  ccContactEmail: "Contact's email",
  ccCompanyName: 'Company name',
  ccCountry: 'Country',
  ccAddress: 'Address line',
  ccCityState: 'City, State',
  ccTaxId: 'Tax ID',
  ccRFC: 'RFC',
  ccBankName: 'Bank name',
  ccAccountNumber: 'Account number',
  ccAccountNumberIban: 'Account Number or IBAN',
  ccRoutingNumber: 'Routing number / ABA',
  ccClabeNumber: 'CLABE number',
  ccAccountCurrencyType: 'Account currency',
  ccProviderRelation: 'Beneficiary relationship',
  ccAddContact: 'Add contact',
  ccEditContact: 'Edit contact',
  ccConfirmationTitle: 'Ready!',
  ccConfirmationMessage: 'was successfully added',
  ccEditConfirmationMessage: 'was successfully edited',
  ccErrorSameEmail1: 'You are trying to add a contact with your own email.',
  ccErrorSameEmail2: 'Please use a different email',
  ccEmailExistMessage: 'This email is already associated with an EFEX user.',
  ccEmailExistButton: 'Add it to your contacts',
  ccSwift: 'Global Payouts',
  ccSwiftCode: 'Swift code',
  ccEfexCountryMessage:
    'EFEX has local rails in the USA, Mexico, and Colombia making our payments to be nearly-instant and in local currency',
  ccSwiftCountryMessage: 'Send money globally to +140 countries with SWIFT',
  ccCUSTOMER: 'Client',
  ccCREDITOR: 'Creditor',
  ccDEBTOR: 'Debtor',
  ccSUPPLIER: 'Supplier',
  ccPARENT_COMPANY: 'Headquarters',
  ccOTHER: 'Others',
  ccbankCountryCode: 'Country of the bank to which you are making the payment',
  ccCompanyNameHelper:
    'Please ensure that the company name matches exactly the name officially registered in the company.',
  ccPersonNameHelper:
    'Make sure to enter the full name and last name of the person, exactly as it appears on their official ID.',
  ccRegisterUserUsaRoutingWarning:
    'Please ensure that you enter the correct routing number based on the account type (wire/ACH).',
  ccErrorNoSpecialCharacters: 'Special characters are not allowed nor accents',
  ccCompanyDocumentationWarning:
    'Please include the real and complete data of each beneficiary to avoid delays in your payments',
  ccStakeAddressMessage:
    'Please add the address of the beneficiary, not of their bank.',
  ccAddressMaxLength: 'Address must be less than 60 characters',
  ccCityMaxLength: 'City must be less than 60 characters',
  ccStateMaxLength: 'State must be less than 60 characters',
  ccPostCodeMaxLength: 'Post code must be less than 15 characters',
  ccFullLastName: 'Full last names',
  ccSendPayment: 'Send payment',
  ccWrongBankName: 'Bank name is invalid',
  ccPoBoxError:
    "PO Box addresses aren't allowed. Enter a valid street address.",
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const CREATE_CONTACT_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    ccProviderTitle: 'Datos del receptor',
    ccEntityTitle: 'Entidad',
    ccEntityPerson: 'Persona',
    ccEntityCompany: 'Empresa',
    ccRepresentativeName: 'Nombre del contacto',
    ccName: 'Nombre',
    ccContactPhone: 'Teléfono de contacto (Opcional)',
    ccContactEmail: 'Email de contacto',
    ccCompanyName: 'Nombre de la empresa',
    ccCountry: 'País',
    ccAddress: 'Dirección',
    ccCityState: 'Ciudad, Estado',
    ccTaxId: 'Tax ID',
    ccRFC: 'RFC',
    ccBankName: 'Nombre del banco',
    ccAccountNumber: 'Número de cuenta',
    ccAccountNumberIban: 'Número de cuenta o IBAN',
    ccRoutingNumber: 'Número de routing / ABA',
    ccClabeNumber: 'Número CLABE',
    ccAccountCurrencyType: 'Moneda de la cuenta',
    ccProviderRelation: 'Relación con el beneficiario',
    ccAddContact: 'Agregar contacto',
    ccEditContact: 'Editar contacto',
    ccConfirmationTitle: '¡Listo!',
    ccConfirmationMessage: 'fue agregado correctamente',
    ccEditConfirmationMessage: 'fue editado correctamente',
    ccErrorSameEmail1:
      'Estas tratando de agregar un contacto con tu propio correo.',
    ccErrorSameEmail2: 'Por favor utiliza un correo distinto',
    ccEmailExistMessage: 'Este correo ya esta asociado a un usuario EFEX.',
    ccEmailExistButton: 'Agrégalo a tus contactos',
    ccSwift: 'Transferencias Globales',
    ccSwiftCode: 'Código Swift',
    ccEfexCountryMessage:
      'EFEX tiene rieles de pago locales en EEUU, México y Colombia ofreciéndole a nuestros usuarios pagos instantáneos y en moneda local',
    ccSwiftCountryMessage:
      'Envía transferencias a +140 países alrededor del mundo con SWIFT',
    ccCUSTOMER: 'Cliente',
    ccCREDITOR: 'Acreedor',
    ccDEBTOR: 'Deudor',
    ccSUPPLIER: 'Proveedor',
    ccPARENT_COMPANY: 'Matriz',
    ccOTHER: 'Otros',
    ccbankCountryCode: 'País del banco al que esta realizando el pago',
    ccCompanyNameHelper:
      'Por favor, asegúrese de que el nombre de la empresa coincide exactamente con el nombre registrado oficialmente en la empresa.',
    ccPersonNameHelper:
      'Asegúrate de ingresar el nombre y apellidos completos de la persona, exactamente como aparecen en su identificación oficial.',
    ccRegisterUserUsaRoutingWarning:
      'Por favor, asegúrate de ingresar el número de routing adecuado según el tipo de cuenta (wire/ACH).',
    ccErrorNoSpecialCharacters:
      'No se permiten caracteres especiales ni acentos',
    ccCompanyDocumentationWarning:
      'Por favor incluye la data completa y real de cada beneficiario para evitar demoras en tus transferencias',
    ccStakeAddressMessage:
      'La dirección debe ser del domicilio del beneficiario y no del banco receptor.',
    ccAddressMaxLength: 'La dirección debe tener menos de 60 caracteres',
    ccCityMaxLength: 'La ciudad debe tener menos de 60 caracteres',
    ccStateMaxLength: 'El estado debe tener menos de 60 caracteres',
    ccPostCodeMaxLength: 'El código postal debe tener menos de 15 caracteres',
    ccFullLastName: 'Apellidos completos',
    ccSendPayment: 'Enviar pago',
    ccWrongBankName: 'El nombre del banco es inválido',
    ccPoBoxError:
      'Las direcciones tipo Correo Postal no están permitidas. Ingresa una dirección física válida.',
  },
};

export default CREATE_CONTACT_LANGUAGE_LABELS;
